import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@library-shared/base/base.component';
import { CCInfo } from '@library-shared/models/cc-info';
import { CCMonth } from '@library-shared/models/cc-month';
import { CCYear } from '@library-shared/models/cc-year';
import { CreditCardUtility } from '@library-shared/models/credit-card-utility';
import { spSite_Client_By_DomainX } from '@models/StoredProcs-Extended/spSite_Client_By_DomainX';
import { ValidationCallbackData } from 'devextreme/ui/validation_rules';
import moment from 'moment';

@Component({
    selector: 'app-credit-card-information',
    templateUrl: './credit-card-information.component.html',
    styleUrls: ['./credit-card-information.component.scss'],
    standalone: false
})
export class CreditCardInformationComponent extends BaseComponent implements OnInit {
    @Input() ccInfo: CCInfo;
    @Input() validationGroup;
    @Input() site: spSite_Client_By_DomainX;

    showAmex = false;
    showDiscover = false;
    showVisa = false;
    showMasterCarrd = false;

    monthList: CCMonth[];
    yearList: CCYear[];

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.monthListGenerate();
        this.yearListGenerate();
        this.onCCChange();
    }

    onCCChange() {
        this.showAmex = false;
        this.showDiscover = false;
        this.showMasterCarrd = false;
        this.showVisa = false;
        switch (CreditCardUtility.CardInfo(this.ccInfo.cc_card_number).cardType) {
            case 'AMEX':
                this.showAmex = true;
                break;
            case 'DISC':
                this.showDiscover = true;
                break;
            case 'VISA':
                this.showVisa = true;
                break;
            case 'MC':
                this.showMasterCarrd = true;
                break;
            default:
                this.showAmex = this.site?.allow_amex;
                this.showDiscover = true;
                this.showVisa = true;
                this.showMasterCarrd = true;
                break;
        }
    }

    monthListGenerate() {
        const list: CCMonth[] = [];

        for (let x = 1; x <= 12; x++) {
            list.push({
                monthName: moment(x + '/1/2017').format('MMM') + ` (${x})`,
                monthValue: x,
            });
        }

        this.monthList = list;
    }

    yearListGenerate() {
        const list: CCYear[] = [];
        const startYear = new Date().getFullYear();

        for (let x = startYear; x <= startYear + 15; x++) {
            list.push({
                yearName: '' + x,
                yearValue: x,
            });
        }

        this.yearList = list;
    }

    checkZip(e: ValidationCallbackData) {
        if (('' + e.value).length != 5) {
            return false;
        }
        return true;
    }
}
